// extracted by mini-css-extract-plugin
export default {"logoContainer":"PacienteEmailConfirmation_logoContainer__woMc2","logo":"PacienteEmailConfirmation_logo__YAeYa"};